<app-hero-slider></app-hero-slider>

<app-browse-category></app-browse-category>
<app-explore-collection></app-explore-collection>

<!-- Previous Completed Appointments Section -->
<section class="recent-order section-padding" *ngIf="isAuthenticated$ | async">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="section-header-left">
          <h3 class="text-light-black header-title title">
            Previous Completed Appointments
            <span class="fs-14" *ngIf="(appointments$ | async)?.length">
              <a (click)="goToAllAppointments()" style="cursor: pointer; color: hsl(0.41deg, 75.51%, 38.43%);"
                >See all appointments</a
              >
            </span>
          </h3>
        </div>
      </div>
    </div>

    <!-- Loading Skeleton for Appointments -->
    <div *ngIf="isLoadingAppointments" class="row">
      <div class="col-lg-3 col-md-6 col-sm-6" *ngFor="let i of [1,2,3,4]">
        <div class="product-box mb-md-20">
          <div class="product-img" style="height: 150px; overflow: hidden; background: #f5f5f5; position: relative;">
            <div class="appointment-image-skeleton"></div>
          </div>
          <div class="product-caption">
            <div class="skeleton-text" style="width: 80%; height: 18px; margin-bottom: 8px;"></div>
            <div class="skeleton-text" style="width: 60%; height: 14px; margin-bottom: 8px;"></div>
            <div class="skeleton-text" style="width: 70%; height: 14px; margin-bottom: 8px;"></div>
            <div class="skeleton-text" style="width: 100px; height: 24px; border-radius: 4px;"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Appointments List -->
    <div *ngIf="!isLoadingAppointments">
      <div *ngIf="appointments$ | async as appointments">
        <div
          *ngIf="appointments.length === 0"
          class="text-center"
          style="padding: 40px"
        >
          <p class="text-light-black">No completed appointments found.</p>
        </div>

        <div *ngIf="appointments.length > 0" class="row">
          <div
            *ngFor="let appointment of appointments"
            class="col-lg-3 col-md-6 col-sm-6"
          >
            <div
              class="product-box mb-md-20"
              style="cursor: pointer"
              (click)="goToAppointmentDetail(appointment.id)"
            >
              <div
                class="product-img"
                style="
                  height: 150px;
                  overflow: hidden;
                  background: #f5f5f5;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                "
              >
                <!-- Skeleton Loader -->
                <div
                  *ngIf="isImageLoading(appointment.id)"
                  class="appointment-image-skeleton"
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  "
                ></div>
                <img
                  [src]="appointment.storeInfo?.photoURL"
                  alt="Appointment Image"
                  style="width: 100%; height: 100%; object-fit: cover; position: relative; z-index: 1;"
                  [attr.data-loading]="isImageLoading(appointment.id)"
                  (load)="onImageLoad(appointment.id)"
                  (error)="onImageError(appointment.id)"
                  [style.opacity]="isImageLoading(appointment.id) ? '0' : '1'"
                  [style.transition]="'opacity 0.3s ease-in-out'"
                />
              </div>
              <div class="product-caption">
                <h6 class="product-title">
                  <a
                    class="text-light-black"
                    (click)="$event.stopPropagation()"
                  >
                    {{ appointment.storeInfo?.storeName || "Appointment" }} #{{
                      appointment.id.slice(0, 8)
                    }}
                  </a>
                </h6>
                <p
                  class="text-light-white"
                  *ngIf="appointment.storeInfo?.storeName"
                >
                  <i class="fas fa-store"></i>
                  {{ appointment.storeInfo.storeName }}
                </p>
                <p class="text-light-white">
                  <i class="fas fa-calendar"></i>
                  {{ formatAppointmentDate(appointment.date) }}
                </p>
                <p class="text-light-white" *ngIf="appointment.checkedInAt">
                  <i class="fas fa-check-circle"></i>
                  Checked in:
                  {{ formatAppointmentDate(appointment.checkedInAt) }}
                </p>
                <div class="product-btn">
                  <span
                    class="badge badge-success"
                    style="
                      background-color: hsl(0.41deg, 75.51%, 38.43%);
                      color: white;
                      padding: 5px 10px;
                    "
                  >
                    Completed
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- See All Button -->
        <div *ngIf="appointments.length > 0" class="text-center mt-4">
          <button
            (click)="goToAllAppointments()"
            class="btn btn-primary text-custom-white full-width fw-500"
            style="
              cursor: pointer;
              max-width: 300px;
              margin: 0 auto;
              display: inline-block;
            "
          >
            See All Appointments
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Previous Completed Appointments Section -->

<!-- Blog Posts Section -->
<section class="section-padding">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="section-header-left">
          <h3 class="text-light-black header-title title">
            Latest Blog Posts
            <span class="fs-14" *ngIf="posts.length">
              <a (click)="goToAllBlogs()" style="cursor: pointer; color: hsl(0.41deg, 75.51%, 38.43%);"
                >See all blogs</a
              >
            </span>
          </h3>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 blog-inner clearfix">
        <div class="full-width">
          <ng-container *ngIf="!isLoadingPosts && posts.length; else blogState">
            <div class="row">
              <div
                class="col-xl-4 col-lg-4 col-md-6 col-sm-12"
                *ngFor="let post of posts; trackBy: trackByPostId"
              >
                <article class="blog-services-wrapper main-box mb-xl-20">
                  <div class="post-img">
                    <a [routerLink]="['/blog-details', post.id]">
                      <img
                        [src]="post.afterPhotoUrl || post.beforePhotoUrl"
                        class="img-fluid full-width"
                        [alt]="post.storeName || 'post'"
                      />
                    </a>
                  </div>
                  <div class="post-meta">
                    <div class="author-img">
                      <img
                        [src]="post.userInfo?.photoUrl"
                        class="rounded-circle"
                        [alt]="post.userInfo?.name || 'Author'"
                      />
                    </div>
                    <div class="author-meta">
                      <h6 class="no-margin">
                        <span class="text-light-black">
                          {{ post.userInfo?.name || 'Unknown Author' }}
                        </span>
                      </h6>
                      <p class="no-margin text-light-white">
                        <span class="text-light-white">{{ post.storeName }}</span>
                        |
                        <span>{{ post.createdTime | date: 'longDate' }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="post-content padding-20">
                    <h5>
                      <a [routerLink]="['/blog-details', post.id]" class="text-light-black">
                        {{ post.description || 'View post' }}
                      </a>
                    </h5>
                    <p>
                      {{ post.topics?.join(', ') || post.storeName || 'Recent post' }}
                    </p>
                    <div class="blog-link-wrap">
                      <a [routerLink]="['/blog-details', post.id]" class="btn-first white-btn">Learn More</a>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </ng-container>

          <ng-template #blogState>
            <!-- Loading Skeleton for Blog Posts -->
            <div class="row" *ngIf="isLoadingPosts">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12" *ngFor="let i of [1,2,3,4,5,6]">
                <article class="blog-services-wrapper main-box mb-xl-20">
                  <div class="post-img">
                    <div class="skeleton-image" style="width: 100%; height: 220px; border-radius: 4px;"></div>
                  </div>
                  <div class="post-meta">
                    <div class="author-img">
                      <div class="skeleton-image img-rounded" style="width: 40px; height: 40px;"></div>
                    </div>
                    <div class="author-meta">
                      <div class="skeleton-text" style="width: 150px; height: 16px; margin-bottom: 8px;"></div>
                      <div class="skeleton-text" style="width: 200px; height: 14px;"></div>
                    </div>
                  </div>
                  <div class="post-content padding-20">
                    <div class="skeleton-text" style="width: 80%; height: 20px; margin-bottom: 12px;"></div>
                    <div class="skeleton-text" style="width: 100%; height: 16px; margin-bottom: 8px;"></div>
                    <div class="skeleton-text" style="width: 70%; height: 16px; margin-bottom: 16px;"></div>
                    <div class="skeleton-text" style="width: 120px; height: 36px; border-radius: 4px;"></div>
                  </div>
                </article>
              </div>
            </div>
            <div class="py-4 text-center" *ngIf="!isLoadingPosts && postsError">
              <p class="text-light-black mb-2">{{ postsError }}</p>
              <button class="btn btn-sm btn-primary" (click)="loadPosts()">Try again</button>
            </div>
            <div class="py-4 text-center" *ngIf="!isLoadingPosts && !postsError && !posts.length">
              <p class="text-light-black mb-0">No posts found.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Blog Posts Section -->
